import type { SchemaFieldDefinition } from "@erp/shared-types";
import type { SocketType } from "../types";
import {
  extractionSchemaToOutputSockets,
  type ExtractionSocketDefinition,
} from "./extractionSchemaToSockets";

const SOCKET_ID_REGEX = /^[a-z][a-z0-9_]*$/;

/**
 * Root fields from a pinned extraction schema that become JSON request-body
 * input sockets on `external_http_call` (registered mode).
 */
export function eligibleExternalHttpCallRequestBodyRootFields(
  fields: SchemaFieldDefinition[],
): SchemaFieldDefinition[] {
  return fields.filter((f) => {
    if (f.parentFieldId) return false;
    if (!SOCKET_ID_REGEX.test(f.fieldName)) return false;
    return true;
  });
}

interface ExternalHttpCallInputSocketSpec {
  id: string;
  name: string;
  type: SocketType;
  required: boolean;
  description?: string;
}

/**
 * Typed input sockets from a request JSON body schema snapshot (root fields
 * only), matching the per-field model used for response outputs.
 */
export function schemaRootFieldsToExternalHttpCallRequestBodyInputSocketSpecs(
  rootFieldsFromSnapshot: SchemaFieldDefinition[],
): ExternalHttpCallInputSocketSpec[] {
  const eligible = eligibleExternalHttpCallRequestBodyRootFields(
    rootFieldsFromSnapshot,
  );
  return extractionSchemaToOutputSockets(eligible, {
    idPrefix: "",
    mode: "per_field",
    respectFieldRequired: true,
  }).map((s: ExtractionSocketDefinition) => ({
    id: s.id,
    name: s.name,
    type: s.type,
    required: s.required,
    description: s.description,
  }));
}
